import { Programa } from '@/shared/model/programa.model';
export interface IProgramaIntegrado {
  clave?: string | null;
  nombre?: string | null;
  fechaInicio?: string | null;
  fechaFin?: string | null;
}

export class ProgramaIntegrado implements IProgramaIntegrado {
  constructor(
    public clave?: string | null,
    public nombre?: string | null,
    public fechaInicio?: string | null,
    public fechaFin?: string | null
  ) {}

  static fromObject(object: IProgramaIntegrado): ProgramaIntegrado {
    return Object.assign(new ProgramaIntegrado(), object);
  }
}

/**
 * Contiene un programa relacioando a la institución del programa de la solicitud con indicador seleccionable.
 */
export interface IProgramaIntegradoSeleccionable {
  programa?: Programa;
  disponible?: boolean;
  estePrograma?: boolean;
}

export class ProgramaIntegradoSeleccionable implements IProgramaIntegradoSeleccionable {
  constructor(public programa?: Programa, public disponible?: boolean, public estePrograma?: boolean) {}
}
